import { ENV_API_URL } from '@common/env';

export const API_URL = ENV_API_URL;
export const FIREBASE_TOKEN_KEY = 'firebase-token';
